module.exports = __webpack_public_path__ + "static/media/portrait.e5640cf7.jpg";